export { getYearPredictionsZodiac2024 } from "./getZodiacPredictions2024";
export { getYearPredictionsZodiac2025 } from "./getZodiacPredictions2025";
